import type { ReactNode } from 'react';

import { classNames } from '@/utils/classNames';

import styles from '@/styles/common.module.css';

type CardProps = {
  children: ReactNode;
  className?: string;
  tone?: 'default' | 'soft';
};

export function Card({ children, className, tone = 'default' }: CardProps): JSX.Element {
  return (
    <div
      className={classNames(
        styles.card,
        styles.cardPadded,
        tone === 'soft' && styles.cardSoft,
        className,
      )}
    >
      {children}
    </div>
  );
}
